






















































































































































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import DeleteConfirm from '@/components/DeleteConfirm.vue';
import { AxiosResponse } from 'axios';
// import { userMdl } from '@/models/userMdl';
import { groupCastMdl, groupMdl } from '@/models/groupMdl';
import EditGroup from '@/components/childWindow/EditGroup.vue';
import GroupMachine from '@/components/childWindow/GroupMachine.vue';
import GroupMail from '@/components/childWindow/GroupMail.vue';
import GroupUser from '@/components/childWindow/GroupUser.vue';
/* eslint-enable no-unused-vars */

@Component({
    name: 'user_list',
    components: { DeleteConfirm, EditGroup, GroupMachine, GroupMail, GroupUser },
    head: {
        title: {
            inner: 'グループ一覧',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class group_list extends BaseForm {
    // ヘッダー情報
    private groupDataHeader: any = [
        { text: 'グループID', align: 'center', value: 'group_id', width: 150 },
        // { text: '会社名', align: 'center', value: 'corp_name' },
        { text: 'グループ名', align: 'center', value: 'group_name' },
        { text: '編集', align: 'center', value: 'actions', sortable: false, width: 200 },
        { text: '削除', align: 'center', value: 'delete', sortable: false, width: 100 },
    ];
    //private userDataList: userMdl[] = []; // ユーザデータ一覧
    private groupDataList: any = []; // グループデータ一覧
    private itemsPerPage: number = 10; // 1ページに表示するアイテム数
    private deleteConfirmFlg: boolean = false; // 削除確認ダイアログ
    private deleteGroupId: number = 0; // 削除するグループID
    private selectGroupName: string = '';
    private selectGroupId: number = 0; // 選択されたグループID
    private selectGroupOfficeCode: string = '';
    private selectGroupPref: number = -1;
    private editGroupFlg: boolean = false; // グループ編集ダイアログ
    private machineGroupFlg: boolean = false; // グループ紐づけマシン編集ダイアログ
    private mailGroupFlg: boolean = false; // グループメール編集ダイアログ
    private userGroupFlg: boolean = false; // グループユーザ編集ダイアログ

    created() {
        if (this.authority > 2) {
            this.groupDataHeader.unshift({ text: '会社名', align: 'center', value: 'corp_name', width: 250 });
        }
        this.getGroupList();
    }
    private async getGroupList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('group_list.php', 1, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.groupDataList = resp.data.items.map(function(v: any) {
                        return new groupMdl(groupMdl.toJsonDataOnModel(new groupCastMdl(v)));
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 削除確認ダイアログクローズ
    private closeDeleteDialog(value: boolean) {
        this.deleteConfirmFlg = false;
        if (value) {
            this.groupDelete(this.deleteGroupId);
        }
    }

    // グループ編集
    private onClickEdit(item: groupMdl) {
        if (item) {
            let idx: number = this.groupDataList.findIndex(
                ({ group_id }: { group_id: number }) => group_id === item.group_id
            );
            this.selectGroupName = this.groupDataList[idx].group_name;
            this.selectGroupId = item.group_id;
            this.selectGroupOfficeCode = item.office_code_list;
            this.selectGroupPref = item.pref_num;
        } else {
            this.selectGroupName = '';
            this.selectGroupId = -1;
            this.selectGroupOfficeCode = '';
            this.selectGroupPref = -1;
        }
        this.editGroupFlg = true;
    }
    // グループ機器編集
    private onClickMachineEdit(item: groupMdl) {
        if (item) {
            let idx: number = this.groupDataList.findIndex(
                ({ group_id }: { group_id: number }) => group_id === item.group_id
            );
            this.selectGroupName = this.groupDataList[idx].group_name;
            this.selectGroupId = item.group_id;
            this.machineGroupFlg = true;
        }
    }
    // グループメール編集
    private onClickMailEdit(item: groupMdl) {
        if (item) {
            let idx: number = this.groupDataList.findIndex(
                ({ group_id }: { group_id: number }) => group_id === item.group_id
            );
            this.selectGroupName = this.groupDataList[idx].group_name;
            this.selectGroupId = item.group_id;
            this.mailGroupFlg = true;
        }
    }
    // グループユーザ編集
    private onClickUserEdit(item: groupMdl) {
        if (item) {
            let idx: number = this.groupDataList.findIndex(
                ({ group_id }: { group_id: number }) => group_id === item.group_id
            );
            this.selectGroupName = this.groupDataList[idx].group_name;
            this.selectGroupId = item.group_id;
            this.userGroupFlg = true;
        }
    }
    // グループメール編集ダイアログクローズ
    private closeMailGroupDialog(value: boolean) {
        this.mailGroupFlg = false;
    }
    // グループ編集ダイアログクローズ
    private closeEditGroupDialog(value: boolean) {
        this.editGroupFlg = false;
        if (value) {
            // グループデータ取得
            this.getGroupList();
        }
    }
    // グループ機器編集ダイアログクローズ
    private closeMachineGroupDialog(value: boolean) {
        this.machineGroupFlg = false;
        if (value) {
            // グループデータ取得
            // this.getGroupList();
        }
    }
    // グループユーザ編集ダイアログクローズ
    private closeUserGroupDialog(value: boolean) {
        this.userGroupFlg = false;
        if (value) {
            // グループデータ取得
            // this.getGroupList();
        }
    }
    // グループ削除
    private onClickDelete(item: groupMdl) {
        this.deleteConfirmFlg = true;
        this.deleteGroupId = item.group_id;
    }
    private async groupDelete(group_id: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { group_id: group_id };
            const resp: AxiosResponse<any> = await this.$http.post('group_delete.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    // データの再取得
                    await this.getGroupList();
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'データ削除完了',
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ削除失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ削除失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
